
import { mapActions, mapGetters } from "vuex";

import i18n from "@/plugins/i18n";

import CSV from "@/components/templates/CSV.vue";
import CopyButton from "@/components/templates/CopyButton.vue";
import Top from "@/components/templates/Top.vue";

import * as views from "@/plugins/utils/View";
import * as crud from "@/plugins/utils/Crud";
import * as action from "@/store/actions";
import Vue from "vue";
import { TimeExten, View } from "@/types/conf";
import TimeExtenDetail from "./TimeExtenDetail.vue";
import msgCodes from "@/extendedFunctions/msgCodes";

export default Vue.extend({
  name: "TimeExtenOut",
  data: () => ({
    expand: [],
    canDelete: false,
    canCreate: false,
    canUpdate: false,
    extenList: [] as any[],
    alertType: "",
    alertMessage: "",
    timeList: [] as TimeExten[],
    selectedItem: null as TimeExten | null,
    search: "",
    dialog: false,
    dialogDelete: false,
    loadingList: false,
  }),
  computed: {
    ...mapGetters({
      views: "auth/views",
      hoverColor: "lookAndFeel/hoverColor",
      menuIconColor: "lookAndFeel/menuIconColor",
      menuFontColor: "lookAndFeel/menuFontColor",
    }),
    translatedTimeList() {
      return this.timeList.map(item => ({
        ...item,
        daysAndHours: item.options
          .map(opt => {
            const dayMap = {
              Mon: "monday",
              Tue: "tuesday",
              Wed: "wednesday",
              Thu: "thursday",
              Fri: "friday",
              Sat: "saturday",
              Sun: "sunday",
            };

            const translatedDays = opt.days
              .split(/[, -]+/)
              .map(day => this.$t(`misc.${dayMap[day]}`))
              .join(', ');

            return `${translatedDays}: ${this.formatTime(opt.from)} - ${this.formatTime(opt.to)}`;
          })
          .join("\n")
      }));
    }
  },
  async mounted() {
    this.loadingList = true;
    this.timeList = await this.getAllTime(action.TIMEOPTION_EXTEN_CONTROLLER);
    this.actionHandler();
    this.loadingList = false;
  },

  components: {
    CSV,
    CopyButton,
    Top,
    TimeExtenDetail
  },

  watch: {
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },

  methods: {
    ...mapActions({
      getAllTime: "crudService/getList",
      deleteTimemain: "crudService/deleteObject",
    }),
    formatTime(time: string): string {
      if (!time) return "";
      if (time.includes(":")) return time; // ya está formateado
      if (time.length === 4) {
        const h = time.slice(0, 2);
        const m = time.slice(2);
        return `${h}:${m}`;
      }
      return time;
    },
    getExtenNumberById(id) {
      const match = this.extenList.find(e => e.id === id);
      return match ? match.number : id;
    },
    headers() {
      return [
        { text: '', value: 'data-table-expand' },
        { text: this.$t("misc.actions"), value: "actions", sortable: false, align: "left" },
        { text: this.$t("misc.name"), value: "name" },
      ];
    },
    actionHandler() {
      const view = this.views.find((v: View) => v.name == views.TIME);
      if (view) {
        this.canDelete = view.actions.includes(crud.DELETE);
        this.canCreate = view.actions.includes(crud.CREATE);
        this.canUpdate = view.actions.includes(crud.UPDATE);
      }
    },

    async deleteItem(item: TimeExten) {
      this.selectedItem = item;
      this.dialogDelete = true;
    },

    async deleteItemConfirm() {
      const response = await this.deleteTimemain({
        action: action.TIMEOPTION_EXTEN_CONTROLLER,
        id: this.selectedItem!.id
      });

      // This set if the form must persist or don't
      this.dialogDelete = response >= 400;

      this.alertMessage = msgCodes(response, false).alertMessage;
      this.alertType = msgCodes(response, false).alertType;

      this.$store.dispatch('snackbar/showSnack', {
        message: this.alertMessage,
        color: this.alertType,
        timeout: 3000,
      });

      this.refreshList();
    },

    closeDelete() {
      this.dialogDelete = false;
    },

    async refreshList() {
      this.loadingList = true;
      this.timeList = await this.getAllTime(action.TIMEOPTION_EXTEN_CONTROLLER);
      this.actionHandler();
      this.loadingList = false;
    },
  },
});
